<svelte:options runes={false} />

<script>
  export let variant = 'notice';
  export let as = 'p';
  export let ariaLabel = null;
</script>

<svelte:element this={as} class="notice" class:error={variant === 'error'} aria-label={ariaLabel}>
  <slot />
</svelte:element>
